import axiosServices from './request';

const AppApi = axiosServices('/appcenter/v1.0');

export default {

  /** 书刊分类 */
  getTempleList: AppApi('get', 'assistTemplet/getTempleList'),

  /** 书刊标签 */
  labelGroupList: AppApi('get', 'label/labelGroupList'),

  /** 书刊标签（目的） */
  purLabelList: AppApi('get', 'label/purLabelList'),

  /** 获取用户可选应用类型列表 */
  listByPartyId: AppApi('get', 'appType/listByPartyId'),

  /** 获取我的应用列表 */
  getList4AdviserQrcode: AppApi('get', 'app/getList4AdviserQrcode'),

  /** 获取伴学工具 */
  listPageRaysApp: AppApi('get', 'appRays/listPageRaysApp'),

  /** 我的列表 */
  list4QrcodeEx: AppApi('get', 'app/list4QrcodeEx'),

  /** 获取用户可创建的app类型 */
  listByAppCreate: AppApi('get', 'appType/listByAppCreate')
};
